var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[(_vm.sortedTasks && _vm.sortedTasks.length)?_c('Chart',{attrs:{"tasks":_vm.sortedTasks,"users":_vm.allUsers}}):_c('div',[_c('Preloader')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }